export default __webpack_public_path__ + "static/media/WooStoreFront2.b6d83292.jpeg";